import React from "react";
import { popularMenuFood } from "../popularMenu";
import { BsStarFill } from "react-icons/bs";

function PopularMenu({addToCart}) {
  return (
    <>
      <div className="space-y-8">
        <h1 className="text-4xl tracking-wider font-bold">
          <span className="border-b-4 border-orange-400">Featured</span> items
        </h1>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-2">
          {/* begin */}
          {popularMenuFood.map((menu) => (
            <div className="space-y-4 bg-gradient-to-b from-white to-green-100 rounded-3xl flex items-center justify-center pt-4 flex-col">
              <div className="flex relative">
                <img src={menu.imgURL} className="rounded-full h-48" />

                <span className="absolute bottom-4 right-0 inline-flex items-center justify-center h-14 w-14 rounded-full bg-green-800 text-white border border-2">
                  <span className="font-medium leading-none text-white">
                    ${menu.price}
                  </span>
                </span>
              </div>

              <div className="flex flex-row items-center justify-center space-x-2">
                <div className="flex  relative z-0 overflow-hidden">
                  <BsStarFill className="text-yellow-500" />
                  <BsStarFill className="text-yellow-500" />
                  <BsStarFill className="text-yellow-500" />
                  <BsStarFill className="text-yellow-500" />
                  <BsStarFill className="text-yellow-500" />
                  
                </div>

                <div>
                  <span className="text-orange-400 text-sm">(5.00)</span>
                </div>
              </div>

              <div>
                <span className="text-green-900 font-bold">{menu.title}</span>
              </div>

              <div className="">
                <p class="text-gray-400 px-4 text-center">{menu.foodDesc}</p>
              </div>

              <div className="">
                <button
                 
                  className="mt-8 rounded-lg bg-green-800 hover:bg-green-900 text-white py-2 px-8 rounded-full"
                  onClick={()=> addToCart(menu)}
                >
                  Order Now
                </button>
              </div>
            </div>
          ))}

          {/* end */}
        </div>
      </div>
    </>
  );
}

export default PopularMenu;
